import { render, staticRenderFns } from "./TrainingItem.vue?vue&type=template&id=f7254fe6"
import script from "./TrainingItem.vue?vue&type=script&lang=js"
export * from "./TrainingItem.vue?vue&type=script&lang=js"
import style0 from "./TrainingItem.vue?vue&type=style&index=0&id=f7254fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports